import { Component, DestroyRef, EventEmitter, inject, Output } from '@angular/core';
import _ from 'lodash';
import { ApiQuery } from '../../web-services/api/api.query';
import { TranslatorService } from '../../services/translator_service';
import { ResponsiveService } from '../../services/responsive.service';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../directives/rtldiv-directive.directive';
import { NumberWithDescriptionComponent } from '../../components/number-with-description/number-with-description.component';
import { MatDividerModule } from '@angular/material/divider';
import moment from 'moment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-active-bins',
  standalone: true,
  imports: [MatCardModule,TranslateModule,RTLDivDirectiveDirective,NumberWithDescriptionComponent,MatDividerModule],
  templateUrl: './active-bins.component.html',
  styleUrl: './active-bins.component.scss'
})
export class ActiveBinsComponent {
	@Output() showCMP = new EventEmitter<boolean>(true);
	nonActiveBins = 0;
	totalActive = 0;
	totalGreenInWebsite = [];
	totalYellowInWebsite = [];
	totalRedInWebsite = [];
	translate;
	isMobile: boolean = false;
	spinnerActive:boolean = true;
	usageType = 1;
	end_of_day_forecast_red = 0;
	end_of_day_forecast_yellow = 0;
	end_of_day_forecast_green = 0;
	private readonly destroyRef = inject(DestroyRef);

	constructor(private translator: TranslatorService,private responsiveService: ResponsiveService,
		private apiQuery:ApiQuery) {
		this.translate = this.translator.translate;
	}

	ngOnInit() {
		this.onResize();
		this.responsiveService.checkWidth();
		this.spinnerActive = true;
		this.apiQuery.user$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((user:any) => {
			if (!user) return;
			if(user["usage_type_id"] != 1){
				this.usageType = user["usage_type_id"];
			}
		});

		combineLatest([
			this.apiQuery.filteredBasicBins$,
			this.apiQuery.filteredDailyWorkPlan$
		  ]).pipe(takeUntilDestroyed(this.destroyRef))
		  .subscribe(([bins,workPlans])=>{	
			this.spinnerActive = true;	
			if(bins.length == 0 || workPlans.length == 0)return;			
			this.spinnerActive = false;	
			let plan : any[] = [];
			_.each(workPlans, (item:any) => {
				plan.push(item);				
			});
			let totalNumOfGreenBinsInWorkPlan = [];

			let totalNumOfRedBinsInSite = [];
			let totalNumOfYellowBinsInSite = [];
			let totalNumOfGreenBinsInSite = [];

			_.each(plan, (item) => {
				_.each(item["Vehicle_info"], (vehicleInfo) => {						
					_.each(vehicleInfo["Bins_collection_info"], (collectedInfo) => {
						let bin = bins.find((bin:any) => bin.bin_id == collectedInfo.bin_id);
						if(bin){
							totalNumOfGreenBinsInWorkPlan.push(bin);
						}
					});
				});
			});

			_.each(bins, (bin) => {
				if(bin['bin_collection_mode'] == "2" && !totalNumOfGreenBinsInWorkPlan.some(gb => gb.bin_id == bin['bin_id'])){
					const now = moment();
					const endOfDay = moment().endOf('day');
					const remainingTime = endOfDay.diff(now, 'hours');

					const average_daily_fill_rate_in_percent = bin['average_daily_fill_rate_in_percent'];
					const fill_level_percent = bin['Bin_live_Data'].fill_level_percent;
					const redThreshold = bin['Bin_thresholds'].red_status_fill_level_in_percent;
					const yellowThreshold = bin['Bin_thresholds'].yellow_status_fill_level_in_percent;
					const greenThreshold = bin['Bin_thresholds'].green_status_fill_level_in_percent;

					if(remainingTime > 0){
						let expectedStatus = Number(Number(fill_level_percent + ((average_daily_fill_rate_in_percent/ 24) * remainingTime)).toFixed(0));
						if(expectedStatus > 100){
							expectedStatus = 100;
						}
						if(expectedStatus <= greenThreshold){
							totalNumOfGreenBinsInSite.push(bin);
						}else if(expectedStatus > greenThreshold && expectedStatus <= yellowThreshold){
							totalNumOfYellowBinsInSite.push(bin);
						}else if(expectedStatus > yellowThreshold && expectedStatus <= redThreshold){
							totalNumOfRedBinsInSite.push(bin);
						}
					}else{
						if (fill_level_percent <= greenThreshold) {
							totalNumOfGreenBinsInSite.push(bin);
						} else if(fill_level_percent > greenThreshold && fill_level_percent <= yellowThreshold) {
							totalNumOfYellowBinsInSite.push(bin);
						} else if(fill_level_percent > yellowThreshold && fill_level_percent <= redThreshold) {
							totalNumOfRedBinsInSite.push(bin);
						}
					}
				}
			});

			this.totalActive = bins.length;
			this.nonActiveBins = _.filter(bins, b => b['bin_collection_mode'] == "1").length;

			this.totalGreenInWebsite = _.filter(bins, b => b['Bin_live_Data'].color_status_id == 0 && b['bin_collection_mode'] == "2");
			this.totalYellowInWebsite = _.filter(bins, b => b['Bin_live_Data'].color_status_id == 1 && b['bin_collection_mode'] == "2");
			this.totalRedInWebsite = _.filter(bins, b => b['Bin_live_Data'].color_status_id == 2 && b['bin_collection_mode'] == "2");			

			this.end_of_day_forecast_red = totalNumOfRedBinsInSite.length;
			this.end_of_day_forecast_yellow = totalNumOfYellowBinsInSite.length;
			this.end_of_day_forecast_green = totalNumOfGreenBinsInSite.length + totalNumOfGreenBinsInWorkPlan.length;
		  });
	}
	
	closeCMP(){
		this.showCMP.emit(false);
	}

	onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	  }
}
